import { get, forEach } from 'lodash'
import Vue from 'vue'

export default () => ({
    state: {
        locks: {},
    },
    getters: {
        getLock: state => entity => get(state.locks, entity),
        getAllLocks: state => state.locks,
    },
    mutations: {
        setLock: (state, data) => {
            const entity = get(data, 'entity')
            const user = get(data, 'user')
            const ttl = get(data, 'ttl')
            Vue.set(state.locks, entity, { user, ttl })
        },
        lockTTLTick: state => {
            forEach(state.locks, (v, k) => {
                if (v.ttl > 0) {
                    v.ttl -= 1
                }
            })
        },
    },
})
